<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2>店铺申请</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForm"
          size="small"
          label-width="110px"
        >
          <el-form-item label="申请平台" prop="brandId">
            <el-select
              v-model="searchForm.platformId"
              placeholder="请选择申请平台"
              filterable
              clearable
            >
              <el-option
                v-for="item in platformList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户ID" prop="name">
            <el-input
              v-model="searchForm.uid"
              placeholder="请输入用户ID"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="用户昵称" prop="goodsNo">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入用户昵称"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="用户等级" prop="brandId">
            <el-select
              v-model="searchForm.brandId"
              placeholder="请选择用户等级"
              filterable
              clearable
            >
              <el-option
                v-for="item in brandList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="申请时间" prop="brandId">
            <el-date-picker
              style="width: 215px"
              v-model="applyTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item style="padding-bottom: 10px">
            <el-button type="primary" @click="fetchData('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="fetchData('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
      </div>
      <div id="base-list">
        <lb-table
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="list"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo"
          :page-size="searchForm.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable
  },
  data () {
    return {
      dataList: {
        list: [
          { title: '矩阵管理', path: '', type: '0' },
          { title: '店铺申请', path: '', type: '1' }
        ]
      },
      applyTime: [],
      searchForm: {
        platformId: '',
        uid: '',
        name: '',
        applyStartTime: '',
        applyEndTime: '',
        pageNo: 1,
        pageSize: 10
      },
      list: [
        {
          name: '天兰',
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        }
      ],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: '申请平台', prop: 'miniAppName', minWidth: '220' },
        { label: '用户昵称', prop: 'name', minWidth: '220' },
        { label: '用户ID', prop: 'uid', minWidth: '120' },
        // { label: '等级', prop: 'categoryName', minWidth: '120' },
        { label: '申请时间', prop: 'applyTime', minWidth: '200' },
        { label: '用户姓名', prop: 'userName', minWidth: '120' },
        { label: '联系电话', prop: 'phone', minWidth: '120' },
        { label: '店铺类型', prop: 'type', minWidth: '100' },
        {
          label: '操作',
          minWidth: '120',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <span style='color:#409EFF;cursor:pointer' onClick={() => { this.todetail(scope.row, 'look') }}>查看</span>
                <span style='color:#409EFF;cursor:pointer;margin-left:10px' onClick={() => { this.todetail(scope.row, 'edit') }}>编辑</span>
              </div >
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      platformList: [],
      selectionGoods: []
    }
  },
  created () {
    this.goodsPlatforms()
    this.fetchData()
  },
  beforeRouteEnter (to, from, next) {
    if (from.name == 'shopApplyDetail') {
      next(vm => {
        vm.fetchData();
      });
    } else {
      next(vm => {
        vm.fetchData();
      });
    }
  },
  methods: {
    fetchData (type) {
      if (type == 'reset') {
        this.searchForm = {}
        this.applyTime = []
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      if (this.applyTime) {
        this.searchForm.applyStartTime = this.applyTime[0]
        this.searchForm.applyEndTime = this.applyTime[1]
      } else {
        this.searchForm.applyStartTime = ''
        this.searchForm.applyEndTime = ''
      }

      this.$api.getShopApplyList(this.searchForm).then(res => {
        if (res.code == 0) {
          this.list = res.data.list
          this.page.totalNum = res.data.totalNum
        }
      })
    },
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.searchForm.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.fetchData()
    },
    goodsPlatforms () {
      const params = {
        userId: null,
        username: null,
        phone: null,
        vipLevel: null,
        categoryIds: null,
        openTimeStart: null,
        openTimeEnd: null,
        status: 1
      }
      this.$api.goodsPlatforms(params).then((res) => {
        this.platformList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    add () {
      this.$router.push({
        name: 'platListDetail',
        query: {}
      })
    },
    setting () {
      this.$router.push({
        name: 'settingPlatform',
        query: {}
      })
    },
    todetail (row, type) {
      if (type == 'look') {
        this.$router.push({
          name: 'shopApplyDetail',
          query: {
            id: row.id
          }
        })
      } else {
        this.$router.push({
          name: 'shopApplyEdit',
          query: {
            id: row.id
          }
        })
      }

    }
  }
}
</script>

<style scoped lang="scss">
.container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 5px;
}
.title {
  display: flex;
  justify-content: space-between;
}
#base-list {
  margin-top: 20px;
}
:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;
  a {
    margin: 0 5px;
  }
}
.search-form {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }
    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;
      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>

